import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import colors from '../../constants/colors';

const RecoverPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            await axiosInstance.post('/auth/forgot-password', { email });
            setSuccess('Um email com instruções para recuperar a tua senha foi enviado.');
        } catch (err) {
            setError('Erro ao enviar email de recuperação. Por favor, tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={6} lg={5}>
                    <Card className="shadow-sm">
                        <Card.Body className="p-4">
                            <h2 className="text-center mb-4" style={{ color: colors.dark }}>Recuperar Senha</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        placeholder="O teu email"
                                        disabled={loading}
                                        style={{ borderColor: colors.secondary }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Por favor insira um email válido.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="d-grid gap-2">
                                    <Button
                                        type="submit"
                                        size="lg"
                                        disabled={loading}
                                        style={{ backgroundColor: colors.secondary, borderColor: colors.secondary, color: colors.light }}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                    style={{ color: colors.secondary }}
                                                />
                                                A processar...
                                            </>
                                        ) : (
                                            'Enviar'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                            <div className="mt-4 text-center">
                                <p className="mb-0" style={{ color: colors.textGray }}>
                                    Lembrou-se da tua senha? <Link to="/login" style={{ color: colors.secondary }}>Iniciar Sessão</Link>
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default RecoverPassword;